import type { CSSProperties } from 'react';
import { pickCss } from '@/shared/lib/css-utils';
import css from './slider.module.scss';

const styles = pickCss(css, css.root);

type SliderProps = {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  'aria-label'?: string;
  id?: string;
  className?: string;
  style?: CSSProperties;
};

/**
 * Range slider for bounded numeric input. The filled portion is driven by a
 * `--fill` custom property so the track shows progress without extra DOM.
 */
export const Slider = ({
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  disabled,
  id,
  className,
  style,
  'aria-label': ariaLabel,
}: SliderProps) => {
  const fill = max > min ? ((value - min) / (max - min)) * 100 : 0;
  return (
    <input
      aria-label={ariaLabel}
      className={styles({ isDisabled: !!disabled }, className)}
      disabled={disabled}
      id={id}
      max={max}
      min={min}
      onChange={(e) => onChange(Number(e.target.value))}
      step={step}
      style={{ ...style, '--fill': `${fill}%` } as CSSProperties}
      type="range"
      value={value}
    />
  );
};
